// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "confirm__title-2szoT";
export { _1 as "__esModule", _2 as "confirm__title" }
export default { "__esModule": _1, "confirm__title": _2 }
